export interface AccountMigration {
  email: string | null;
  launchDate: Date | null;
}
